import React from 'react';
import { Box, Text } from 'ink';
import { DEFAULT_TERMINAL_WIDTH } from '../constants';
import { BaseTool, toolContentWidth } from './tools/BaseTool';
import { isTruncatable, truncate } from './tools/truncate';
import type { WakeMessage } from './wake_message';

interface WakeCardProps {
  wake: WakeMessage;
  expanded: boolean;
  columns?: number;
}

const firedAtLabel = (firedAt: Date): string =>
  [
    firedAt.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }),
    firedAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false }),
  ].join(' ');

export const WakeCard: React.FC<WakeCardProps> = ({
  wake,
  expanded,
  columns = DEFAULT_TERMINAL_WIDTH,
}) => {
  const message = wake.message.trim();
  const truncatable = isTruncatable(message);

  return (
    <BaseTool
      label={`Scheduled check-in fired at ${firedAtLabel(wake.firedAt)}`}
      expanded={expanded}
      columns={columns}
    >
      {message.length > 0 && (
        <Box flexDirection="column" paddingLeft={2} width={toolContentWidth(columns)}>
          <Text dimColor>{expanded ? message : truncate(message)}</Text>
          {!expanded && truncatable && <Text dimColor>(truncated)</Text>}
        </Box>
      )}
    </BaseTool>
  );
};
